import { sendGTMEvent } from '@b-stock/fe-core/bstock-next/components'

import type { GTMEvent } from '@/helpers/types/gtmTypes'

/**
 * Type-safe wrapper around fe-core's sendGTMEvent.
 * Accepts any GTMEvent union member and handles the Record<string, unknown> cast.
 * Always clears ecommerce context first per GA4 best practices.
 */
export function sendTypedGTMEvent(event: GTMEvent) {
  sendGTMEvent({ ecommerce: null })
  sendGTMEvent(event as unknown as Record<string, unknown>)
}
